// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3sXHI","filesListContainer":"PosDisputesFiles_filesListContainer__3hI0e","filesButton":"PosDisputesFiles_filesButton__1pih1"};